import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StorageItem } from '@vsolv/packages/storage/domain';
import { fileThumbUrl, fileTypeLabel } from '../../utils/file-thumb.util';

/** A claim file at a glance: the image itself, or a tile with its type. */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-file-thumb',
  templateUrl: './file-thumb.component.html',
  standalone: false,
})
export class FileThumbComponent {
  @Input() set file(file: Partial<StorageItem.Model> | null | undefined) {
    this.url = fileThumbUrl(file);
    this.label = fileTypeLabel(file);
    this.failed = false;
  }

  /** Width and height in pixels. */
  @Input() size = 40;

  /** Round, for chips. */
  @Input() round = false;

  url: string | null = null;
  label: string | null = null;
  failed = false;
}
